var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('displayDetailWin',_vm._b({attrs:{"shiquArray":_vm.shiquArray,"detailObj":_vm.detailObj,"detailNetObj":_vm.detailNetObj,"deviceProperty":_vm.deviceProperty,"deviceType":_vm.deviceType}},'displayDetailWin',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }